import { businessDate } from './stock';

export function saleDateError(value, today = businessDate()) {
  const timestamp = Date.parse(`${value}T00:00:00Z`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '') || !Number.isFinite(timestamp) ||
      new Date(timestamp).toISOString().slice(0,10) !== value || value > today) {
    return 'Select a sale date of today or earlier.';
  }
  return '';
}
